import { render, staticRenderFns } from "./gamePoint.vue?vue&type=template&id=cee15696&"
import script from "./gamePoint.vue?vue&type=script&lang=js&"
export * from "./gamePoint.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./gamePoint.vue?vue&type=style&index=1&id=cee15696&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports